/* eslint-disable */
import { mapGetters, mapState, mapActions } from 'vuex';
import disqus from '@/components/disqus/disqus.vue';
import marketPayoutSushi from '@/components/market/market-payout-sushi/market-payout-sushi.vue';
import alertBox from '@/components/generics/alert-box/alert-box.vue';
import tabs from '@/components/generics/tabs/tabs.vue';
import accountVerifyMixin from '@/mixins/accountVerify';
import headerTagsMixin from '@/mixins/headerTags';
import headerHeightMixin from '@/mixins/headerHeight';
import { isMarketSettled, isMarketDisabled, hasMarketPayout } from '@/utils/helpers';
import { MODALS } from '@/components/app/app-modals/app-modals';
import { waitForStatusReady } from '@/utils/mutex';
import sushiMarketDiscussionWidget from "./components/sushi-market-discussion-widget/sushi-market-discussion-widget.vue";
import sushiMarketLinksWidget from "./components/sushi-market-links-widget/sushi-market-links-widget.vue";
import marketWatch from '@/components/market/market-watch/market-watch.vue';
import constants from '@/constants';
import { BRAND } from '@/components/brand-name/brand-name.js';
import pageSushiMarketCharts from '@/components/pages/page-market-detail-sushi/pages/sushi-market-charts/sushi-market-charts.vue';
import pageSushiMarketDiscussion from '@/components/pages/page-market-detail-sushi/pages/sushi-market-discussion/sushi-market-discussion.vue';
import pageSushiMarketHistory from '@/components/pages/page-market-detail-sushi/pages/sushi-market-history/sushi-market-history.vue';
import pageSushiMarketRules from '@/components/pages/page-market-detail-sushi/pages/sushi-market-rules/sushi-market-rules.vue';
import pageSushiMarketContracts from '@/components/pages/page-market-detail-sushi/pages/sushi-market-contracts/sushi-market-contracts.vue';
import pageSushiMarketLinks from '@/components/pages/page-market-detail-sushi/pages/sushi-market-links/sushi-market-links.vue';
import pageSushiMarketResearch from '@/components/pages/page-market-detail-sushi/pages/sushi-market-research/sushi-market-research.vue';
import pageSushiMarketMethodology from '@/components/pages/page-market-detail-sushi/pages/sushi-market-methodology/sushi-market-methodology.vue';
import marketAlertV2 from '@/components/market/v2/market-alert-v2/market-alert-v2.vue';
import marketSiteAlertV2 from '@/components/market/v2/market-site-alert-v2/market-site-alert-v2.vue';
import loaderMixin from '@/mixins/loader';
import contentLoaderMixin from '@/mixins/contentLoader';
import marketCharts from '@/components/market/market-detail-charts/market-detail-charts.vue';
import scrollTo from '@/utils/scrollTo'
import Contract from '@/models/contract';
import { parseQuery } from '@/utils/helpers';
import {
  VALUES, OPERATIONS,
} from '@/components/market/market-contract-horizontal-sushi/market-contract-horizontal-sushi'
import purchaseOfferSushiMobileBar from '@/components/purchase/sushi/purchase-offer-sushi-mobile-bar/purchase-offer-sushi-mobile-bar.vue';
import { BOTTOM_WIDGET_FOOTER_MODES } from '@/store/modules/trade';
import log from '@/logger';
import store from '@/store';

const DEFAULT_PAGE_TITLE = BRAND;

export const NAVIGATION_TABS = {
  CONTRACTS: 'contracts',
  RESEARCH: 'research',
  METHODOLOGY: 'methodology',
  RULES: 'rules',
  CHARTS: 'charts',
  HISTORY: 'history',
  DISCUSSION: 'discussion',
  LINKS: 'links'
};

const ROUTE_DRIVEN_TABS = [
  NAVIGATION_TABS.CONTRACTS,
  NAVIGATION_TABS.RESEARCH,
  NAVIGATION_TABS.METHODOLOGY,
  NAVIGATION_TABS.RULES,
  NAVIGATION_TABS.CHARTS,
  NAVIGATION_TABS.HISTORY,
  NAVIGATION_TABS.DISCUSSION,
  NAVIGATION_TABS.LINKS,
];

const AUTH_REQUIRING_TABS = [
  NAVIGATION_TABS.HISTORY,
  NAVIGATION_TABS.LINKS,
]

function resolveActiveTab(tab) {
  if (!ROUTE_DRIVEN_TABS.includes(tab)) {
    return  NAVIGATION_TABS.CONTRACTS;
  }
  if (AUTH_REQUIRING_TABS.includes(tab) && !store.getters['user/isLoggedIn']) {
    return NAVIGATION_TABS.CONTRACTS;
  }
  return ROUTE_DRIVEN_TABS.includes(tab) ? tab : NAVIGATION_TABS.CONTRACTS;
}

function buildDiscussionQuery(query, commentId = '', commentThreadId = 0) {
  const nextQuery = {
    ...query,
    tab: NAVIGATION_TABS.DISCUSSION,
  };

  if (Number(commentThreadId) > 0) {
    nextQuery.commentThreadId = Number(commentThreadId);
  } else {
    delete nextQuery.commentThreadId;
  }

  if (commentId) {
    nextQuery.commentId = commentId;
  } else {
    delete nextQuery.commentId;
  }

  return nextQuery;
}

function buildTabQuery(query, tab) {
  const nextQuery = {
    ...query,
  };

  delete nextQuery.commentThreadId;
  delete nextQuery.commentId;

  if (tab && tab !== NAVIGATION_TABS.CONTRACTS) {
    nextQuery.tab = tab;
  } else {
    delete nextQuery.tab;
  }

  return nextQuery;
}

function buildCommentHash(commentId = '') {
  return commentId ? `#comment-${commentId}` : '';
}

function normalizeCommentThreadId(commentThreadId) {
  const normalized = Number(commentThreadId);

  return Number.isFinite(normalized) && normalized > 0 ? normalized : 0;
}

function resolveRouteMarketId(route) {
  return Number(route && route.params ? route.params.marketId : 0);
}

function resolveDiscussionCommentId(route) {
  if (route && route.query && route.query.commentId) {
    return route.query.commentId;
  }

  if (route && route.hash && route.hash.indexOf('#comment-') === 0) {
    return route.hash.replace('#comment-', '');
  }

  return '';
}

function getCurrentLocationQuery() {
  const query = parseQuery(window.location.search || '');

  delete query[''];

  return query;
}

export default {
  mixins: [
    accountVerifyMixin,
    headerTagsMixin,
    headerHeightMixin,
    loaderMixin,
    contentLoaderMixin,
  ],
  components: {
    alertBox,
    disqus,
    tabs,
    sushiMarketDiscussionWidget,
    sushiMarketLinksWidget,
    marketPayoutSushi,
    marketWatch,
    pageSushiMarketCharts,
    pageSushiMarketDiscussion,
    pageSushiMarketHistory,
    pageSushiMarketRules,
    pageSushiMarketContracts,
    pageSushiMarketLinks,
    pageSushiMarketResearch,
    pageSushiMarketMethodology,
    marketAlertV2,
    marketSiteAlertV2,
    marketCharts,
    purchaseOfferSushiMobileBar,
  },
  props: {
    showRules: {
      type: Boolean,
      default: false,
    },
    marketId: {
      type: Number,
      required: true,
    },
    prerendered: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      NAVIGATION_TABS,
      titleHovered: false,
      watchRecalculating: false,
      discussionWidgetRouteSwap: 1,
      isResetting: false,
      showAllContracts: false,
      activeTab: resolveActiveTab(this.$route.query.tab),
      requestedDiscussionCommentId: resolveDiscussionCommentId(this.$route),
      requestedDiscussionCommentThreadId: normalizeCommentThreadId(this.$route.query.commentThreadId),
      showHistory: false,
      hideMainChart: false,
      isTitleSticky: false,
      initialised: false,
      tabScrollPositions: {},
    };
  },
  metaInfo() {
    if (this.market && this.market.marketId) {
      return {
        title: this.market.seoTitle,
        link: [
          { rel: 'canonical', href: `${window.location.href}` },
        ],
        meta: [
          { name: 'description', content: this.market.seoDescription },
          { itemprop: 'name', content: this.market.seoTitle },
          { itemprop: 'description', content: this.market.seoDescription },
          { itemprop: 'image', content: this.market.imageName },
          { property: 'og:title', content: this.market.seoTitle },
          { property: 'og:type', content: 'article' },
          { property: 'og:image', content: this.market.imageName },
          { property: 'og:description', content: this.market.seoDescription },
          { property: 'og:site_name', content: BRAND },
          { property: 'og:url', content: `${window.location.href}` },
        ],
      };
    }
    return {};
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
    ...mapGetters('app', [
      'isLayoutDesktop', 'isLayoutMobile', 'isCommentEnabled',
      'isAfterHours', 'isRegularMaintenance', 'isExtendedMaintenance',
      'isPinningEnabled', 'oddsModeEnabled'
    ]),
    ...mapState('app', ['previousRoute', 'showOdds']),
    ...mapState('market', [
      'market', 'contracts', 'marketLoadError',
      'marketIsEngineBusy', 'marketIsEngineBusyMessage',
      'isDiscussionPinned',
    ]),
    ...mapState('trade', [
      'tradeOptions',
      'bottomWidgetFooterModeContractsSection',
      'hasStoredBottomWidgetFooterModePreference',
    ]),
    ...mapState('popup', ['currentPopup']),
    ...mapState('notifications', ['lastConfirmedContractData']),
    ...mapState('user', ['status']),
    isShortcutWidgetVisible() {
      return this.market !== null && !!this.market.marketId && !this.isMarketDisabled && this.initialised && !this.isResetting && this.isLayoutMobile && this.activeTab !== NAVIGATION_TABS.CONTRACTS;
    },
    displayedMarketName() {
      return (this.isLayoutMobile && this.isTitleSticky)
        ? this.market.marketShortName
        : this.market.marketName;
    },
    toolbarStyleModifiers() {
      return {
        top: `${this.headerHeight}px`,
      };
    },
    titleStyleModifiers() {
      if (!this.isTitleSticky) {
        return {};
      }
      return {
        top: `${this.headerHeight}px`,
      };
    },
    watchIconVisible() {
      const statuses = [
        constants.MARKET_EXPIRED,
        constants.MARKET_SETTLED,
      ];
      return this.isLoggedIn && !statuses.includes(this.market.status);
    },
    discussionWidgetKey() {
      return `market--${this.discussionWidgetRouteSwap.toString()}`;
    },
    navigationTabs () {
      let results = [
        {
          name: NAVIGATION_TABS.CONTRACTS,
          title: 'Contracts',
        },
      ];

      // results = [
      //   ...results,
      //   {
      //     name: NAVIGATION_TABS.CHARTS,
      //     title: 'Charts',
      //   },
      // ]

      results = [
        ...results,
        {
          name: NAVIGATION_TABS.DISCUSSION,
          title: 'Discussion',
        },
        {
            name: NAVIGATION_TABS.RULES,
            title: 'Rules',
            meta: {
              numRuleComments: this.market ? this.market.numRuleComments : 0,
            },
          },
      ]

      if (this.isLoggedIn) {
        results = [
          ...results,
          {
            name: NAVIGATION_TABS.HISTORY,
            title: 'History',
          },
          {
            name: NAVIGATION_TABS.LINKS,
            title: 'Lists',
          },
        ]
      }


      return results;
    },
    isMarketDisabled() {
      return isMarketDisabled(this.market);
    },
    isMarketSettled() {
      return isMarketSettled(this.market);
    },
    isPayoutAvailable() {
      return this.isLoggedIn && hasMarketPayout(this.market) && !this.isMarketSettled;
    },
    title() {
      return `Market details for ${this.market.symbol}--${this.market.marketId}`;
    },
    showEngineBusyNotification() {
      return (
        (this.market.isEngineBusy && this.market.isEngineBusyMessage) ||
        (this.marketIsEngineBusy && this.marketIsEngineBusyMessage)
      );
    },
    engineBusyNotificationContent() {
      return this.market.isEngineBusyMessage || this.marketIsEngineBusyMessage;
    },
    ogImageSrc() {
      return this.prerendered !== '' && this.market && this.market.imageName;
    },
    showEconomicIndicator() {
      return [2, 3, 4].includes(this.market.econIndicatorTradeStatus);
    },
    showDiscussionWidget() {
      return this.isPinningEnabled && this.isLoggedIn && this.isDiscussionPinned && this.isCommentEnabled;
    },
    showMarketLinksWidget() {
      return this.isPinningEnabled && this.isLoggedIn;
    },
  },
  methods: {
    ...mapActions('insight', ['getMarketFeeds']),
    ...mapActions('market', [
      'getMarket', 'clearMarket', 'clearMarketEngineBusyMessage',
    ]),
    ...mapActions('popup', ['setCurrentPopup', 'setTradePopup']),
    ...mapActions('trade', [
      'setTradeOptions', 'setTradePrice', 'setTradeQuantity', 'clearOrderBook',
      'setBottomBetSlipExtendedMode', 'toggleHidePurchaseForContractId',
      'setBottomWidgetFooterMode', 'setBottomWidgetFooterModeContractsSection',
    ]),
    isMarketDetailPath(path = '') {
      return typeof path === 'string' && path.indexOf('/markets/detail/') === 0;
    },
    shouldPreserveMobileFooterMode(fromRoute = null) {
      if (fromRoute && fromRoute.name === 'market-details') {
        return true;
      }

      return this.isMarketDetailPath(this.previousRoute);
    },
    applyDefaultMobileFooterMode({ fromRoute = null } = {}) {
      if (!this.isLayoutMobile) {
        return;
      }

      if (!this.hasStoredBottomWidgetFooterModePreference &&
        !this.shouldPreserveMobileFooterMode(fromRoute)) {
        this.setBottomWidgetFooterModeContractsSection(BOTTOM_WIDGET_FOOTER_MODES.QUICK_SWITCH);
      }

      if (this.activeTab === NAVIGATION_TABS.CONTRACTS) {
        this.setBottomWidgetFooterMode(this.bottomWidgetFooterModeContractsSection);
        return;
      }

      this.setBottomWidgetFooterMode(BOTTOM_WIDGET_FOOTER_MODES.QUICK_SWITCH);
    },
    initStickyObserver() {
      if (!('IntersectionObserver' in window)) {
        this.initScrollFallback();
        return;
      }

      if (this.stickyObserver) {
        this.stickyObserver.disconnect();
      }

      this.stickyObserver = new IntersectionObserver(
        ([entry]) => {
          if (!this.$refs.stickySentinel || !this.isLayoutMobile) {
            this.isTitleSticky = false;
            return;
          }

          if (entry.isIntersecting) {
            this.isTitleSticky = false;
            return;
          }

          const isAbove = entry.boundingClientRect.top <= this.headerHeight;
          this.isTitleSticky = isAbove;
        },
        {
          rootMargin: `-${this.headerHeight}px 0px 0px 0px`,
          threshold: [0]
        }
      );

      // Use a small delay to ensure the DOM is fully rendered after isResetting toggles
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.$refs.stickySentinel) {
            this.stickyObserver.observe(this.$refs.stickySentinel);
          }
        }, 50);
      });
    },
    initScrollFallback() {
      if (this.onScroll) return;
      this.onScroll = () => {
        if (!this.$refs.stickySentinel || !this.isLayoutMobile) {
          this.isTitleSticky = false;
          return;
        }
        const rect = this.$refs.stickySentinel.getBoundingClientRect();

        // If rect.top > headerHeight, the sentinel is below the threshold (user scrolled to top)
        if (rect.top > this.headerHeight) {
          this.isTitleSticky = false;
        } else {
          this.isTitleSticky = true;
        }
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
    },
    onWatchToggle() {
      this.watchRecalculating = true;
      this.retrieveMarketData({ marketId: this.marketId, clearOrderBook: false, clearMarket: true, loader: false })
        .then(() => {
          this.watchRecalculating = false;
      }).catch(() => {
        this.watchRecalculating = false;
      })
    },
    onTitleMouseOver() {
      this.titleHovered = true;
    },
    onTitleMouseLeave() {
      this.titleHovered = false;
    },
    syncDiscussionLocation(commentId = '', commentThreadId = 0) {
      const currentQuery = getCurrentLocationQuery();
      const resolvedRoute = this.$router.resolve({
        name: this.$route.name,
        params: {
          ...this.$route.params,
          dontReload: true,
        },
        query: buildDiscussionQuery(currentQuery, commentId, commentThreadId),
        hash: buildCommentHash(commentId),
      });

      // Keep Disqus-only state out of Vue Router so the routed page shell does not remount.
      window.history.replaceState(window.history.state, document.title, resolvedRoute.href);
    },
    syncTabLocation(tab) {
      const currentQuery = getCurrentLocationQuery();
      const resolvedRoute = this.$router.resolve({
        name: this.$route.name,
        params: {
          ...this.$route.params,
          dontReload: true,
        },
        query: buildTabQuery(currentQuery, tab),
        hash: '',
      });

      window.history.replaceState(window.history.state, document.title, resolvedRoute.href);
    },
    updateDiscussionRequest({ commentId = '', commentThreadId = 0 } = {}) {
      this.requestedDiscussionCommentId = commentId;
      this.requestedDiscussionCommentThreadId = normalizeCommentThreadId(commentThreadId);
      this.syncDiscussionLocation(this.requestedDiscussionCommentId, this.requestedDiscussionCommentThreadId);
    },
    onOpenDiscussion() {
      this.activeTab = NAVIGATION_TABS.DISCUSSION;
      this.updateDiscussionRequest();
    },
    onOpenDiscussionComment(comment) {
      const commentId = comment && comment.commentId ? comment.commentId : '';
      const commentThreadId = comment && comment.commentThreadId ? Number(comment.commentThreadId) : 0;

      this.activeTab = NAVIGATION_TABS.DISCUSSION;
      this.updateDiscussionRequest({
        commentId,
        commentThreadId,
      });
    },
    onDiscussionRequestChange(payload = {}) {
      this.updateDiscussionRequest(payload);
    },
    navigationTabChange(name) {
      log.info(`[TABS] Change to: ${name} from ${this.activeTab}`)
      if (this.activeTab === NAVIGATION_TABS.DISCUSSION) {
        this.discussionWidgetRouteSwap += 1;
      }

      this.tabScrollPositions[this.activeTab] = window.scrollY || window.pageYOffset;

      const isTheSameTab = this.activeTab === name;
      this.activeTab = name;
      if (!isTheSameTab) {
        if (this.activeTab === NAVIGATION_TABS.DISCUSSION) {
          this.updateDiscussionRequest();
        } else {
          this.requestedDiscussionCommentId = '';
          this.requestedDiscussionCommentThreadId = 0;
          this.syncTabLocation(this.activeTab);
        }
        if (this.activeTab === NAVIGATION_TABS.CONTRACTS) {
          this.setBottomWidgetFooterMode(this.bottomWidgetFooterModeContractsSection)
        }
        this.$nextTick(() => {
          const $el = document.querySelector('.page-market-detail-sushi__content');
          if ($el) {
            let topOffset = this.headerHeight;

            if (this.isLayoutDesktop) {
              const $toolbar = document.querySelector('.page-market-detail-sushi__toolbar');
              if ($toolbar) {
                topOffset += $toolbar.offsetHeight;
              }
              if (this.tabScrollPositions[name] !== undefined) {
                log.info(`Scrolling to last position for ${name}`);
                window.scrollTo(0, this.tabScrollPositions[name]);
                return;
              }
            } else {
              const $title = document.querySelector('.page-market-detail-sushi__title');
              if ($title) {
                topOffset += $title.offsetHeight;
              }
              if (this.tabScrollPositions[name] !== undefined) {
                log.info(`Scrolling to last position for ${name}`);
                window.scrollTo(0, this.tabScrollPositions[name]);
                return;
              }
            }
            scrollTo($el, 250, 'linear', null, topOffset);
          }
        });
      }
    },
    retrieveMarketData({ marketId, clearMarket = true, clearOrderBook = true, loader = true }) {
      if (clearOrderBook) {
        this.clearOrderBook();
      }
      if (marketId) {
        if (loader) {
          this.loaderAdd(document.body);
        }
        const commentThreadId = this.$route.query.commentThreadId;
        return this.getMarket({ marketId, commentThreadId, skipCache: clearMarket })
          .then((data) => {
            if (loader) {
              this.loaderRemove(document.body);
            }
            if (data.econIndicatorTradeStatus === 3) {
              this.setCurrentPopup(MODALS.AFFILIATIONS);
            }
            this.$nextTick(() => {
              this.initStickyObserver();
              if (this.onScroll) this.onScroll();
            });
          }).catch(() => {
            if (loader) {
              this.loaderRemove(document.body);
            }
            this.$router.push({ name: 'not-found' });
        })
      }
      return Promise.resolve(1);
    },
    addBoxLoading() {
      const $el = document.querySelector('.purchase-offer-desktop-sushi-common-betslip__box');
      if ($el) {
        $el.classList.add('purchase-offer-desktop-sushi-common-betslip__box--loading');
      }

      const $el2 = document.querySelector('.purchase-offer-sushi-mobile-bar');
      if ($el2) {
        $el2.classList.add('purchase-offer-sushi-mobile-bar--loading');
      }
    },
    removeBoxLoading() {
      const $el = document.querySelector('.purchase-offer-desktop-sushi-common-betslip__box');
      if ($el) {
        $el.classList.remove('purchase-offer-desktop-sushi-common-betslip__box--loading');
      }

      const $el2 = document.querySelector('.purchase-offer-sushi-mobile-bar');
      if ($el2) {
        $el2.classList.remove('purchase-offer-sushi-mobile-bar--loading');
      }
    },
    loadHandler(value) {
      if (!this.initialised) {
        this.applyDefaultMobileFooterMode();
        this.startPageSetup();
      }

      this.addBoxLoading();

      if (value) {
        this.retrieveMarketData({
          marketId: this.marketId, clearOrderBook: false, clearMarket: true,
        })
          .then(waitForStatusReady)
          .then(() => {
            if (!this.initialised) {
              this.setupPage();
            } else {
              this.switchContractSideIfNecessaryBecauseOfOwnership();
            }
            this.removeBoxLoading();
            this.initialised = true;
          });
      } else {
        this.retrieveMarketData({
          marketId: this.marketId, clearOrderBook: true, clearMarket: true,
        })
          .then(() => {
            if (!this.initialised) {
              this.setupPage();
            }
            this.removeBoxLoading();
            this.initialised = true;
          });
      }
    },
    switchContractSideIfNecessaryBecauseOfOwnership() {
      if (this.isMarketDisabled) {
        return;
      }

      if (!this.tradeOptions.contractId) {
        return;
      }

      const contract = this.contracts.find(c => c.contractId === this.tradeOptions.contractId);
      if (!contract) {
        return;
      }

      const contractModel = new Contract(contract);
      if (!contractModel.mode || contractModel.mode === this.tradeOptions.operationValue) {
        return;
      }
      log.info('[PURCHASE] switching sides after signin');
      this.setTradeOptions({
        contractId: contract.contractId,
        operationType: OPERATIONS.BUY,
        operationValue: contractModel.mode
      })
      this.setTradePrice(contractModel.mode === VALUES.YES ? contractModel.buyYesCostAsCents : contractModel.buyNoCostAsCents);
    },
    startPageSetup() {
      this.isResetting = true
      this.isTitleSticky = false;
    },
    setupPage() {
      this.isResetting = false
      this.reorganizeTags();
    },
  },
  watch: {
    lastConfirmedContractData(data) {
      const contractIds = (this.contracts || []).map(i => i.contractId);
      if (data && data.matched && contractIds.includes(data.id)) {
        this.showHistory = true;
      }
    },
    isLoggedIn: {
      handler: 'loadHandler',
      immediate: true,
    },
    $route(to, from) {
      if (from && to) {
        this.activeTab = resolveActiveTab(to.query.tab)
        this.requestedDiscussionCommentId = resolveDiscussionCommentId(to);
        this.requestedDiscussionCommentThreadId = normalizeCommentThreadId(to.query.commentThreadId);

        if (resolveRouteMarketId(to) === resolveRouteMarketId(from)) {
          return;
        }

        this.applyDefaultMobileFooterMode({ fromRoute: from });
        this.setBottomBetSlipExtendedMode(false);
        this.startPageSetup()
        this.retrieveMarketData({
          marketId: to.params.marketId,
          clearOrderBook: true,
          clearMarket: true,
        }).then(() => {
          this.setupPage();
        })
      }
    },
  },
  beforeDestroy() {
    if (this.stickyObserver) {
      this.stickyObserver.disconnect();
    }
    if (this.onScroll) {
      window.removeEventListener('scroll', this.onScroll);
    }
    this.clearMarketEngineBusyMessage();
    this.setTradeOptions(null);
    this.toggleHidePurchaseForContractId(null);
    this.clearMarket();
    this.clearOrderBook();
    this.setBottomBetSlipExtendedMode(false);
    document.title = DEFAULT_PAGE_TITLE;
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-market-detail-sushi/page-market-detail-sushi.js